import { Folder, Link, Page } from '@app/components/various/Icons';
import { Tooltip } from '@app/components/various/Tooltip';
import { cn } from '@app/utils/cn';
import { IconComponent, Navigation } from '@typings';
import { useTranslation } from 'react-i18next';

interface Props {
  type: Navigation.AnyMenuItemType;
}

export const NavigationItemIcon = ({ type }: Props) => {
  const { t } = useTranslation(['common']);

  const iconMap: Record<Navigation.AnyMenuItemType, { icon: IconComponent; name: string; className?: string }> = {
    folder: {
      icon: Folder,
      name: t('common:folder'),
    },
    link: {
      icon: Link,
      name: t('common:link'),
    },
    page: {
      icon: Page,
      name: t('common:page_one'),
    },
  };

  const { icon: Icon, name, className } = iconMap[type];

  return (
    <Tooltip content={<span className="capitalize">{name}</span>}>
      <span>
        <Icon className={cn('size-5 text-neutral-40', className)} />
      </span>
    </Tooltip>
  );
};
